/**
 * Applies the manually sorted order configured in the `PDP Grouping Options` section to the product
 * grouping lists, by adding a `v-order-<index>` class (a flex `order`) to each matching option.
 *
 * The order has to be re-applied after every render of the main product section: the morph
 * reconciles each option's `class` attribute back to the server-rendered markup, which drops the
 * classes added here.
 */
function applyProductGroupingOptionsOrder() {
  if (!window.productGroupingOptionsSettings) return;

  window.productGroupingOptionsSettings.blocks.forEach(function (block) {
    const optionName = block.option_name;
    const sortedList = block.sorted_list;
    if (!optionName || !sortedList) return;

    // Find the elements with the matching data-name attribute.
    const selectOptions = document.querySelectorAll(
      `.pdp-group-js[data-name="${optionName}"]`,
    );

    if (selectOptions.length === 0) return;
    selectOptions.forEach(function (selectOption) {
      // Find the list items within the select option and apply the order classes.
      const listItems = selectOption.querySelectorAll("li");
      listItems.forEach(function (listItem) {
        sortedList.forEach((sortEntry, index) => {
          sortEntry = sortEntry.trim();
          if (
            listItem.dataset.value === sortEntry ||
            listItem.dataset.feature === sortEntry
          ) {
            listItem.classList.add(`v-order-${index}`);
          }
        });
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  applyProductGroupingOptionsOrder();

  // `variant:change` is dispatched on the document after the main product section is morphed
  document.addEventListener("variant:change", applyProductGroupingOptionsOrder);
});
